require('../profileSearch/profileListService');
require('../../shared/profileService');

"use strict";

angular.module('app.myHockeyTv.followersFollowing.followersFollowingController', [
  'app.myHockeyTv.profileSearch.profileListService',
  'app.shared.profileService',
])
  .controller('app.myHockeyTv.followersFollowing.followersFollowingController', [
    '$scope',
    'app.myHockeyTv.profileSearch.profileListService',
    'app.shared.profileService',
    function ($scope, profileListService, profileService) {
      let search = null;

      $scope.searching = false;
      $scope.followFilter = 'ifollow';
      $scope.profileService = profileService;

      /**
       * @param {UserProfile} user
       * @returns {boolean}
       */
      $scope.showUser = function (user) {
        switch ($scope.followFilter) {
          case 'ifollow':
            return !!user.is_follower;
          case 'followme':
            return !!user.is_following;
          case 'all':
            return !!user.is_following || !!user.is_follower;
        }
      };

      $scope.noFollowMessage = function () {
        if (!$scope.users || !$scope.users.length) {
          switch ($scope.followFilter) {
            case 'ifollow':
              return 'You currently are not following anybody';
            case 'followme':
              return 'You currently have no followers';
            case 'all':
              return 'You have no followers, neither are you following anybody'
          }
        }

        return null;
      };

      $scope.clearSearch = function () {
        $scope.search = null;
        $scope.searchResult = null;
      };

      $scope.$watch('search', _.debounce(function (val) {
        let canceler;
        if (val && val.length > 1) {
          $scope.searching = true;
          if (search) {
            canceler = search.deferred;
          } else {
            canceler = null;
          }
          search = profileListService.search($scope.search, canceler);
          search.promise
            .then((response) => {
              let data = response.data;
              $scope.searchResult = data && data.results;
              $scope.searching = false;
            });
        }
      }), 300);

      profileListService.retrieve()
        .then(function (response) {
          $scope.users = response.data.feed;
        });
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/myHockeyTv/followersFollowing/followersFollowingController.js